import React, {useState} from "react";
import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Divider,
    TextField,
    Typography
} from "@mui/material";
import User from "../backend/User";
import Backend from "../backend/Backend";

function NoRolePage() {
    const isEntraID = User.getAuthProvider() === 'entraid' && !User.isMerged();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleLogout = () => {
        User.logout();
        window.location = process.env.PUBLIC_URL + "/login";
    };

    const handleClaim = () => {
        setLoading(true);
        setError(null);
        Backend.postData('/api/actions/mergelocalaccount', {username, password})
            .then(() => {
                setSuccess(true);
                setLoading(false);
                setTimeout(() => {
                    User.logout();
                    window.location = process.env.PUBLIC_URL + "/login";
                }, 2000);
            })
            .catch((err) => {
                setLoading(false);
                const status = err?.response?.status;
                if (status === 401 || status === 403) {
                    setError('Benutzername oder Passwort falsch.');
                } else {
                    setError('Verknüpfung fehlgeschlagen. Bitte versuchen Sie es erneut.');
                }
            });
    };

    return (
        <div style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)'
        }}>
            <Card sx={{maxWidth: 480}}>
                <CardHeader
                    title={"WebTrain"}
                    style={{backgroundColor: "rgb(0,150,136)", color: 'white'}}
                />
                <CardContent sx={{textAlign: 'center', py: 4}}>
                    <Typography variant="h6" gutterBottom>
                        Keine Berechtigung
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{mb: 3}}>
                        Ihrem Konto wurde noch keine Rolle zugewiesen.
                        Bitte wenden Sie sich an Ihren Administrator.
                    </Typography>
                    {isEntraID && !success && (
                        <>
                            <Divider sx={{my: 2}}>oder</Divider>
                            <Typography variant="body2" color="text.secondary" sx={{mb: 2}}>
                                Wenn Sie bereits ein lokales Konto haben, können Sie es hier verknüpfen.
                            </Typography>
                            <TextField
                                label="Benutzername"
                                value={username}
                                onChange={e => setUsername(e.target.value)}
                                fullWidth
                                size="small"
                                sx={{mb: 1}}
                                disabled={loading}
                            />
                            <TextField
                                label="Passwort"
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                fullWidth
                                size="small"
                                sx={{mb: 2}}
                                disabled={loading}
                            />
                            {error && (
                                <Alert severity="error" sx={{mb: 2, textAlign: 'left'}}>{error}</Alert>
                            )}
                            <Button
                                variant="outlined"
                                color="primary"
                                fullWidth
                                onClick={handleClaim}
                                disabled={loading || !username || !password}
                                sx={{mb: 1}}
                            >
                                {loading ? <CircularProgress size={24}/> : 'Lokales Konto verknüpfen'}
                            </Button>
                        </>
                    )}
                    {success && (
                        <Alert severity="success" sx={{mb: 2}}>
                            Konto erfolgreich verknüpft. Sie werden weitergeleitet...
                        </Alert>
                    )}
                    <Box sx={{mt: 2}}>
                        <Button variant="contained" color="primary" onClick={handleLogout}>
                            Abmelden
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </div>
    );
}

export default NoRolePage;
